export default function CCallFunction() {
  return <h2>C Call Function</h2>;
}
